export const subscriptionType = (isTrial) => (isTrial ? 'trial' : 'organic');

/* For the Promo on Trial experiment ("sub-web-checkout-promo-on-trial-123"):
  This experiment includes a number of design changes, all of which are 
  applied under the BEM modifier "--v2". This method is used to grab the
  appropriate styles for each element according to whether the athlete
  should see the experiment.
*/
export const getStyles = (styles, style, shouldAddV2Modifier) =>
  shouldAddV2Modifier ? [styles[style], styles[`${style}V2`]] : [styles[style]];

export default {
  subscriptionType,
  getStyles
};
